import * as Actions from "../constants/Actions";

const initialState = {
  loading: false,
  status: false,
  points: []
};

export default function pointTermReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.SAVE_POINT_LOADING:
      return {
        ...state,
        loading: true
      };
    case Actions.SAVE_POINT_SUCCESS:
      return {
        ...state,
        loading: false,
        message:"Point terms added successfully",
        popup: true,
        status: true
      };
    case Actions.SAVE_POINT_FAILED:
      return {
        ...state,
        loading: false,
        popup: true,
        message:"Failed to add point temrs",
        status: false,
        error: action.error
      };

    case Actions.GET_POINT_LOADING:
      return {
        loading: true,
        points: []
      };
    case Actions.GET_POINT_SUCCESS:
      return {
        ...state,
        loading: false,
        points: action.points
      };
    case Actions.GET_POINT_FAILED:
      return {
        ...state,
        loading: false,
        points: [],
        error: action.error
      };

    case Actions.ALERT_DISMISS:
      return {
        ...state,
        status: false,
        popup: false
      };


      
    default:
      return state;
  }
}
